<template>
  <div>
    <Layout/>
    <h4>Módulos por usuarios</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idModuUsua" class="form-label">IdModuUsua</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModuUsua" name="idModuUsua" v-model="datoModuUsua.idModuUsua" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoModuUsua.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idModulo" name="idModulo" v-model="datoModuUsua.idModulo"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idModulo" class="form-label"> Modulo</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="modulo" name="modulo" v-model="datoModuUsua.modulo" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalModuloLOV"
                      title="Buscar Módulos">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idRol" name="idRol" v-model="datoModuUsua.idRol"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idRol" class="form-label"> Rol</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="rol" name="rol" v-model="datoModuUsua.rol" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalRolLOV"
                      title="Buscar Roles de Usuarios">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarModuUsua" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarModuUsua" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditModuUsua" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdAccesoSesion</th>
          <th scope="col">IdModuUsua</th>
          <th scope="col">IdSesion</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">SesionFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="accesosesion in datosPaginados" :key="accesosesion.idAccesoSesion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(accesosesion.idAccesoSesion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(accesosesion.idAccesoSesion)" title="Editar">edit_square</i></td>
          <td>{{accesosesion.idAccesoSesion}}</td>
          <td>{{accesosesion.idModuUsua}}</td>
          <td>{{accesosesion.idSesion}}</td>
          <td>{{getFormattedDate(accesosesion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{accesosesion.estado}}</td>
          <td>{{getFormattedDate(accesosesion.sesionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteModuUsua(accesosesion.idAccesoSesion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idAccesoSesion" class="form-label">IdAccesoSesion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAccesoSesion" name="idAccesoSesion" v-model="datoAccesoSesion.idAccesoSesion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idModuUsua" class="form-label">IdModuUsua</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idModuUsua" name="idModuUsua" v-model="datoAccesoSesion.idModuUsua" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idSesion" name="idSesion" v-model="datoAccesoSesion.idSesion"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idSesion" class="form-label"> Sesion</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="sesion" name="sesion" v-model="datoAccesoSesion.sesion" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalSesionLOV"
                      title="Buscar Sesiones">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAccesoSesion.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAccesoSesion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAccesoSesion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Modulo -->
    <ModuloLOV @DatosModulo="GetDataModuloLOV($event)"/>
<!-- Lista de Valores: Rol -->
    <RolLOV @DatosRol="GetDataRolLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: AccesoSesion -->
    <AccesoSesionLOVdet @DatosAccesoSesion="GetDataAccesoSesionLOVdet($event)"/>
<!-- Lista de Valores: Sesion -->
    <SesionLOVdet @DatosSesion="GetDataSesionLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
import ModuloLOV from '../../components/lovs/ModuloLOV.vue'
import RolLOV from '../../components/lovs/RolLOV.vue'
// Listas de valores master
// Listas de valores details
import AccesoSesionLOVdet from '../../components/lovs/AccesoSesionLOV.vue'
import SesionLOVdet from '../../components/lovs/SesionLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, ModuloLOV
, RolLOV
// Listas de valores master
// Listas de valores details
, AccesoSesionLOVdet
, SesionLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      moduusuas : [],
      datoModuUsua : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idModuUsua: '',
// Variables master
// Variables details
      accesosesions : [],
      datoAccesoSesion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idModuUsua = this.$route.params.p_idmoduusua
    this.abrirEditar(this.p_idModuUsua)
    this.getAccesoSesions()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoModuUsua.idModuUsua === ''){
        swal("Error!", "El elemento idModuUsua no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuUsua.idUsuario === ''){
        swal("Error!", "El elemento idUsuario no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuUsua.idModulo === ''){
        swal("Error!", "El elemento idModulo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuUsua.idRol === ''){
        swal("Error!", "El elemento idRol no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoModuUsua.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarModuUsua(){
      if(this.validarForm() === 1){
        try {
          this.datoModuUsua.idUsuario = window.sessionStorage.getItem("idUsuario");
          await api.post('/moduusuas', this.datoModuUsua)
          swal("Correcto!", "ModuUsua creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditModuUsua(){
      if(this.validarForm() === 1){
        try {
          await api.post('/moduusuas', this.datoModuUsua)
          swal("Correcto!", "ModuUsua creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoModuUsua={}
      this.titulo   = 'Crear Módulos por usuarios'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idModuUsua){
      this.modalWindow = true
      if(idModuUsua != null){    
           api.get('/vwmoduusuas/'+idModuUsua).then(resp=>{
          this.datoModuUsua = resp.data;
           });
      }
      this.titulo   = 'Editar Módulos por usuarios'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarModuUsua(){
      this.$router.push('/ModuUsua')
    },
// Procedimientos master
// Procedimientos detalle
    async getAccesoSesions() {
      const resp = await api.get('/accesosesions')
      this.accesosesions = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.accesosesions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwaccesosesions/nombre/'+this.nombreBusqueda).then(response=>{
          this.accesosesions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.accesosesions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwaccesosesions').then(response=>{
      this.accesosesions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.accesosesions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoAccesoSesion.idModuUsua === ''){
        swal("Error!", "El elemento idModuUsua no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.idUsuario === ''){
        swal("Error!", "El elemento idUsuario no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.idModulo === ''){
        swal("Error!", "El elemento idModulo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.idRol === ''){
        swal("Error!", "El elemento idRol no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoAccesoSesion.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarAccesoSesion(){
      if(this.validarForm() === 1){
        try {
          this.datoAccesoSesion.idModuUsua = this.datoModuUsua.idModuUsua;
          await api.post('/accesosesions', this.datoAccesoSesion)
          this.getAccesoSesions();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AccesoSesion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAccesoSesion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/accesosesions', this.datoAccesoSesion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AccesoSesion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAccesoSesion={}
      this.titulo   = 'Crear Módulos por usuarios'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idAccesoSesion){
      this.modalWindow = true
      if(idAccesoSesion != null){    
           api.get('/vwaccesosesions/'+idAccesoSesion).then(resp=>{
          this.datoAccesoSesion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Módulos por usuarios'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idAccesoSesion){
      this.modalWindow = true
      if(idAccesoSesion != null){
        this.$router.push('/accesosesionmd/'+idAccesoSesion)
      }
    },
    async deleteAccesoSesion (idAccesoSesion) {
      try{
        await api.delete('/accesosesions/'+idAccesoSesion)
          this.getAccesoSesions()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataModuloLOV(data) {
      this.datoModuUsua.idModulo = data.idModulo;
      this.datoModuUsua.modulo = data.nombre;
    },
//    Lista de Valores
    GetDataRolLOV(data) {
      this.datoModuUsua.idRol = data.idRol;
      this.datoModuUsua.rol = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataAccesoSesionLOVdet(data) {
      this.datoAccesoSesion.idAccesoSesion = data.idAccesoSesion;
      this.datoAccesoSesion.accesoSesion = data.nombre;
    },
//    Lista de Valores
    GetDataSesionLOVdet(data) {
      this.datoAccesoSesion.idSesion = data.idSesion;
      this.datoAccesoSesion.sesion = data.nombre;
    },
// Listas de valores details
  },
}
</script>
